import { SVGAttributes } from 'react'

export function ProhibitIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76536 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.7084C10.5891 7.90671 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM10.125 6C10.126 6.96447 9.78724 7.89847 9.16828 8.63812L3.36188 2.83125C3.96422 2.33015 4.69682 2.01096 5.47396 1.91104C6.25109 1.81112 7.04061 1.9346 7.75013 2.26703C8.45964 2.59946 9.05981 3.12709 9.48038 3.78818C9.90096 4.44927 10.1246 5.21647 10.125 6ZM1.875 6C1.87404 5.03553 2.21276 4.10153 2.83172 3.36188L8.63813 9.16875C8.03578 9.66986 7.30318 9.98904 6.52605 10.089C5.74891 10.1889 4.95939 10.0654 4.24988 9.73297C3.54036 9.40054 2.9402 8.87291 2.51962 8.21182C2.09904 7.55073 1.87545 6.78353 1.875 6Z'
        fill='currentColor'
      />
    </svg>
  )
}
